import axios from "axios";
import _ from "lodash";
import { ENDPOINT } from "../../constants/endpoint.js";

// state
const state = {
  oilPrice: "",
  addOilPrice: "",
  lastOilPrice: ""
};

const getters = {
  getterOilPrice(state) {
    return state.oilPrice;
  },
};

const actions = {
  async getOilPrice(context, data) {
    context.commit("LOADING", { loading: true });
    const url = Endpoint.oilPriceLog();
    await axios
      .get(url)
      .then((res) => {
        const data = _.get(res, "data", []);
        context.commit("SUCCESS_GET_OIL_PRICE", { data });
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  async setOilPrice(context, price) {
    context.commit("LOADING", { loading: true });
    const url = Endpoint.addOilPriceLog();
    await axios
      .post(url, { price })
      .then((res) => {
        const data = _.get(res, "data", []);
        if (res.data) {
          context.commit("SUCCESS_SET_OIL_PRICE", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  async getLastOilPrice(context, data) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.LAST_OIL_PRICE;
    await axios
      .get(url)
      .then((res) => {
        const data = _.get(res, "data", []);
        context.commit("SUCCESS_GET_LAST_OIL_PRICE", { data });
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
};

const mutations = {
  // mutations
  SUCCESS_GET_OIL_PRICE(state, payload) {
    state.oilPrice = payload.data;
  },
  SUCCESS_SET_OIL_PRICE(state, payload) {
    state.addOilPrice = payload.data;
  },
  SUCCESS_GET_LAST_OIL_PRICE(state, payload) {
    state.lastOilPrice = payload.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
